import React, { ElementType } from "react";
import { findVirtualSupplyLinkFor } from "../../service/LinkService";
import { PdsLink } from "@principal/design-system-react";

interface VirtualSupplyLinkProps {
    formNumber: string;
    container?: ElementType;
}

const VirtualSupplyLink = (props: VirtualSupplyLinkProps & Omit<React.HTMLProps<HTMLAnchorElement>, keyof VirtualSupplyLinkProps>) => {
    return (
        <div>
            <PdsLink href={findVirtualSupplyLinkFor(props.formNumber)} target="_blank">
                {props.children}
            </PdsLink>
        </div>
);
}
export default VirtualSupplyLink;
